import type { ProcessItemHeaderProps } from '@ksyos/design-system/dist/components/process-item-header';
import { ServiceActivityType } from '@common/enums';

export function getProcessItemHeaderIconProps(serviceActivityType: ServiceActivityType): {
    accent: ProcessItemHeaderProps['color'];
    icon: ProcessItemHeaderProps['icon'];
} {
    switch (serviceActivityType) {
        case ServiceActivityType.assessment:
        case ServiceActivityType.examination:
        case ServiceActivityType.referral:
        case ServiceActivityType.consultation:
            return {
                accent: 'secondary',
                icon: serviceActivityType,
            };
        case ServiceActivityType.inquiry:
        case ServiceActivityType.unknown:
            return {
                accent: 'primary',
                icon: 'inquiry',
            };

        default:
            return {
                accent: undefined,
                icon: undefined,
            };
    }
}
